import { connect } from "react-redux";
import { mapStateToProps } from "../../store/helpers/mapState";
import { mapDispatchToProps } from "../../store/helpers/mapDispatch";
import React, { useEffect, useState } from "react";
import DatatableComponent from "../../helpers/DatatableComponent";
import moment from "moment";


import {
  AvatarGroup,
  Tooltip,
  Avatar,
  IconButton
} from "@mui/material";
import DeleteDialog from "../../helpers/DeleteDialog";
import { useHistory } from "react-router";
import axios from "axios";
import StatusLayout from "components/Status";
import AttachmentManager from "./AttachmentManager";
import CommentManager from "./CommentManager";

function TaskInitiations({
  location,
  SetSelectedMenu,
  loggedUser,
  systemSettings
}) {
  const mainBackground = systemSettings?.mainBackground;

  const [value, setValue] = React.useState({});
  const [list, setList] = React.useState([]);
  const [id, setId] = React.useState();
  const [count, setCount] = React.useState(0);
  const [selected, setSelected] = React.useState(
    location.state?.status ?? "all"
  );
  const [deleteOpen, setDeleteOpen] = React.useState(false);
  const [options, setOptions] = useState([]);
  const [attachmentOpen, setAttachmentOpen] = React.useState(false);
  const [task, setTask] = React.useState();
  const [commentOpen, setCommentOpen] = React.useState(false);
  const [selectedResource, setSelectedResource] = useState("");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [resources, setResources] = useState([]);
  const [period, setPeriodState] = React.useState({
    startDate: moment().startOf("month"),
    endDate: moment().endOf("month"),
  });

  const updatePeriod = (newPeriod) => {
    setPeriodState(newPeriod);
    // processedData({ data: list });
  };

  const history = useHistory();

  useEffect(() => {
    setSelected(location.state?.status ?? "all");
  }, [location.state]);

  useEffect(() => {
    SetSelectedMenu({
      menu: "team_tasks",
      title: "Team Intiations",
    });
  }, []);

  const fetchResources = async () => {
    const data = await axios.get("api/resource/my-team");
    setResources(data.data.data);
  };

  const allTheMeetings = async () => {
    const data = await axios.get("api/meeting/?status=completed");
    setOptions(data.data.meeting);
  };
  useEffect(() => {
    allTheMeetings();
    fetchResources();
  }, []);

  const columns = [
    {
      name: "name",
      label: "Name",
    },
    {
      name: "id",
      label: "Initiated By",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => {
          const currentTask =
            list && list?.length && list?.find((v) => v.id === value);
          return currentTask?.taskInitiator?.names ?? "Unknown";
        },
      },
    },
    {
      name: "startDate",
      label: "Start Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => moment(value).format("DD/MM/yyyy") ?? "",
      },
    },
    {
      name: "endDate",
      label: "End Date",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (value) => moment(value).format("DD/MM/yyyy") ?? "",
      },
    },
    {
      name: "id",
      label: "Comments",
      options: {
        customBodyRender: (value, tableMeta) => {
          const currentTask =
            list && list?.length && list?.find((v) => v.id === value);

          return (
            <div className="flex flex-row gap-4 ">
        
              {currentTask?.task_comments?.length > 0 && (
                <Tooltip
                  onClick={() => { }}
                  onMouseOver={(e) => {
                    e.stopPropagation();
                    e.target.style.cursor = "pointer";
                  }}
                >
                  <div className="relative flex items-center">
                    <span
                      style={{
                        top: "-6px",
                        right: "-7px",
                        padding: "2px",
                        fontSize: "10px",
                        backgroundColor: mainBackground,
                      }}
                      className="absolute  bg-red-600 text-white rounded-full font-bold flex items-center justify-center"
                    >
                      {currentTask.task_comments.length}
                    </span>
                    <i className="fas fa-comment text-blueGray-500 text-lg"></i>
                  </div>
                </Tooltip>
              )}
            </div>
          );
        },
      },
    },
    {
      name: "task_assignees",
      label: "Assigned to",
      options: {
        customBodyRender: (value, tableMeta) => {
          const rowData = tableMeta.rowData;
          const task_assignees = rowData[6];
          const downloadUrl = "your_download_url";

          if (!task_assignees || task_assignees.length === 0) {
            return "Unassigned";
          }

          // Check if the logged-in user is one of the assignees
          const isMeAssigned = task_assignees.some(
            (assignee) => assignee.Resource.id === loggedUser?.Resource?.id
          );

          if (task_assignees.length === 1) {
            const assigneeName = task_assignees[0].Resource.names;
            return isMeAssigned ? "Me" : assigneeName;
          }

          if (task_assignees.length === 2) {
            const assigneeNames = task_assignees.map((assignee) =>
              assignee.Resource.id === loggedUser?.Resource?.id
                ? "Me"
                : assignee.Resource.names
            );

            return (
              <Tooltip
                title={
                  <div>
                    {assigneeNames.map((name, index) => (
                      <div key={index}>{name}</div>
                    ))}
                  </div>
                }
                arrow={true}
              >
                <div className={"flex flex-start"}>
                  <AvatarGroup
                    sx={{
                      display: "inline-flex",
                      "& .MuiAvatar-root": {
                        width: 24,
                        height: 24,
                        fontSize: 12,
                      },
                    }}
                  >
                    {task_assignees.map((assignee) => (
                      <Avatar
                        key={assignee.Resource.names}
                        alt={assignee.Resource.names}
                        src={
                          assignee.Resource.profile
                            ? `${downloadUrl}/${assignee.Resource.profile}`
                            : undefined
                        }
                        sx={{ width: 24, height: 24 }}
                      />
                    ))}
                  </AvatarGroup>
                </div>
              </Tooltip>
            );
          }

          if (task_assignees.length > 2) {
            const assigneeNames = task_assignees.map((assignee) =>
              assignee.Resource.id === loggedUser?.Resource?.id
                ? "Me"
                : assignee.Resource.names
            );

            return (
              <Tooltip
                title={
                  <div>
                    {assigneeNames.map((name, index) => (
                      <div key={index}>{name}</div>
                    ))}
                  </div>
                }
                arrow={true}
              >
                <AvatarGroup
                  total={task_assignees.length}
                  sx={{
                    display: "inline-flex",
                    "& .MuiAvatar-root": {
                      width: 24,
                      height: 24,
                      fontSize: 12,
                    },
                  }}
                >
                  <Avatar
                    alt={task_assignees[0].Resource.names}
                    src={
                      task_assignees[0].Resource.profile
                        ? `${downloadUrl}/${task_assignees[0].Resource.profile}`
                        : undefined
                    }
                    sx={{ width: 24, height: 24 }}
                  />
                  <Avatar
                    alt={task_assignees[1].Resource.names}
                    src={
                      task_assignees[1].Resource.profile
                        ? `${downloadUrl}/${task_assignees[1].Resource.profile}`
                        : undefined
                    }
                    sx={{ width: 24, height: 24 }}
                  />
                </AvatarGroup>
              </Tooltip>
            );
          }
        },
      },
    },
    {
      name: "status",
      label: "Status",
      options: {
        filter: true,
        sort: true,
        customBodyRender: (status) => {
          let color =
            status === "completed"
              ? "success"
              : status === "canceled"
                ? "error"
                : status === "pending review"
                  ? "text-green-500"
                  : status === "under review"
                    ? "bg-secondary"
                    : status === "missing information"
                      ? "bg-black-500"
                      : status === "forwarded"
                        ? "bg-primary"
                        : "info";
          return (
            <span style={{ fontSize: "0.85rem" }}>
              <StatusLayout status={status} />
            </span>
          );
        },
      },
    },

    {
      name: "id",
      label: "Action",
      options: {
        filter: false,
        sort: false,
        customBodyRender: (v) => (
          <div className="flex items-center">

            <IconButton onClick={() => {
              history.push(`/admin/task/${v}`);
            }}>
              <img
                src={require("../../assets/icons/eye.svg").default}
                alt="Decorative SVG"
                className={
                  " mr-2 text-sm text-blueGray-300"
                }
              />
            </IconButton>

          </div>
        ),
      },
    },
  ];
  const setValue0 = (name, val) => {
    if (!name) {
      return null;
    }

    setValue((v) => {
      v[name] = val;
      return { ...v };
    });
  };
  const onSuccess = () => setCount((v) => v + 1);

    const progressStatus = [
    {
      label: "TO-DO",
      value: "to-do",
    },
    {
      label: "Extended",
      value: "extended",
    },
    {
      label: "In Progress",
      value: "in-progress",
    },
    {
      label: "To verify",
      value: "to-verify",
    },
    {
      label: "Completed",
      value: "completed",
    },
    {
      label: "On-hold",
      value: "on-hold",
    },
    {
      label: "Overdue",
      value: "overdue",
    },
  ];

  return (
    <div className="w-full mb-12 px-4">
      <DeleteDialog
        open={deleteOpen}
        setOpen={() => setDeleteOpen(false)}
        onSuccess={onSuccess}
        url={`/api/task/delete/${id}`}
      />

      <AttachmentManager
        taskId={id}
        task={task}
        openAttachment={attachmentOpen}
        onClose={() => {
          setAttachmentOpen(false);
        }}
        onSuccess={onSuccess}
      />

      <CommentManager
        taskId={id}
        task={task}
        open={commentOpen}
        setOpen={() => setCommentOpen(false)}
        onClose={() => {
          setCommentOpen(false);
        }}
        onSuccess={onSuccess}
      />

      <DatatableComponent
        order={location.state?.order}
        pdf={false}
        search={false}
        viewColumns={false}
        searchfield={true}
        onRowClick={(data, { rowIndex }) => {
          history.push(`/admin/task/${list[rowIndex].id}`);
        }}
        processData={(data) => {
          if (!period.startDate || !period.endDate) {
            setList(data.data);
            return data;
          }

          // Filter tasks based on the selected date range
          const filteredData = data.data.filter((task) => {
            const taskStartDate = moment(task.startDate, "YYYY-MM-DD");
            const taskEndDate = moment(task.endDate, "YYYY-MM-DD");
            const filterStartDate = moment(period.startDate, "YYYY-MM-DD");
            const filterEndDate = moment(period.endDate, "YYYY-MM-DD");

            return (
              taskStartDate.isSameOrAfter(filterStartDate) &&
              taskEndDate.isSameOrBefore(filterEndDate)
            );
          });

          setList(filteredData);
          return { ...data, data: filteredData };
        }}
        elevation={1}
        columns={columns}
        // url={
        //   `/api/task/list/line-manager/${loggedUser?.Resource?.positionId}?count=${count}&resourceId=${selectedResource}${period.startDate && period.endDate
        //     ? `&startDate=${moment(period.startDate).format("YYYY-MM-DD")}&endDate=${moment(period.endDate).format("YYYY-MM-DD")}`
        //     : ""
        //   }`
        // }
        url={
          !period.startDate && !period.endDate
            ? `/api/task/list/line-manager/${loggedUser?.Resource?.positionId}?count=${count}&&resourceId=${selectedResource}&status=${selectedStatus}`
            : `/api/report/tasks/line-manager/${loggedUser?.Resource?.positionId}?count=${count}&resourceId=${selectedResource}${period.startDate && period.endDate ? `&period=${JSON.stringify(period)}&status=${selectedStatus}` : ''}`
        }
        title={
          <div className="flex gap-4 items-center">
            <div className="flex items-center gap-2">
              <label className="text-[#054163] font-medium">From</label>
              <input
                className="px-3 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring focus:ring-blue-300"
                type="date"
                value={
                  Date.parse(period?.startDate)
                    ? moment(period?.startDate).format("YYYY-MM-DD")
                    : ""
                }
                max={period.endDate}
                onChange={(e) => {
                  updatePeriod({
                    ...period,
                    startDate: moment(e.target.value).format("YYYY-MM-DD HH:mm:ss"),
                  });
                }}
              />
            </div>

            <div className="flex items-center gap-2">
              <label className="text-[#054163] font-medium">To</label>
              <input
                className="px-3 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring focus:ring-blue-300"
                type="date"
                value={
                  Date.parse(period?.endDate)
                    ? moment(period?.endDate).format("YYYY-MM-DD")
                    : ""
                }
                min={moment(period?.startDate).format("YYYY-MM-DD")}
                onChange={(e) => {
                  updatePeriod({
                    ...period,
                    endDate: moment(e.target.value).format("YYYY-MM-DD HH:mm:ss"),
                  });
                }}
              />
            </div>

            {/* Reset Date Button */}
            {(period?.startDate || period?.endDate) && (
              <button
                className="text-blue-500 font-medium hover:underline"
                onClick={async () => {
                  try {
                    // Reset the period state to default values
                    updatePeriod({
                      startDate: null,
                      endDate: null,
                    });

                    // Fetch all tasks without filtering by date
                    const response = await axios.get(
                      `/api/task/list/line-manager/${loggedUser?.Resource?.positionId}?count=${count}&resourceId=${selectedResource}`
                    );
                    setList(response.data.data);
                  } catch (error) {
                  }
                }}
              >
                Reset Date
              </button>
            )}

            <select
              className="px-3 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring focus:ring-blue-300"
              value={selectedResource}
              onChange={(e) => {
                setSelectedResource(e.target.value);
              }}
            >
              <option value="">Select Employee</option>
              {resources.map((item) => (
                <option key={item.id} value={item.id}>
                  {item?.names}
                </option>
              ))}
            </select>

            {selectedResource && (
              <button
                className="text-blue-500 font-medium hover:underline"
                onClick={() => {
                  setSelectedResource("");
                }}
              >
                Reset
              </button>
            )}

             <select
              className="px-3 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring focus:ring-blue-300"
              value={selectedStatus}
              onChange={(e) => {
                setSelectedStatus(e.target.value);
              }}
            >
              <option value="">Select Status</option>
              {progressStatus.map((item) => (
                <option key={item.value} value={item.value}>
                  {item.label}
                </option>
              ))}
            </select>
          </div>


        }
      />
    </div>
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(TaskInitiations);
